import { render, staticRenderFns } from "./TableBudgetSimple.vue?vue&type=template&id=2d75d27c&scoped=true"
import script from "./TableBudgetSimple.vue?vue&type=script&lang=js"
export * from "./TableBudgetSimple.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetSimple.vue?vue&type=style&index=0&id=2d75d27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75d27c",
  null
  
)

export default component.exports